/**
 * Pricing Plans Data
 * 
 * Static data for pricing section
 */

export const PRICING_PLANS = [
  {
    id: 1,
    name: 'Basic',
    price: 'Free',
    period: '',
    features: [
      'Limited chat credit allowance',
      'A few trials for the tools',
      'Basic support',
    ],
    buttonText: 'You can try',
    buttonType: 'outline',
    buttonStyle: 'gray', // Special gray button for Basic plan
  },
  {
    id: 2,
    name: 'Pro',
    price: '$29',
    period: '/month',
    features: [
      'Unlimited chatbot',
      'Limited tool usage',
      'Priority support',
    ],
    buttonText: 'Choose Pro',
    buttonType: 'primary',
  },
  {
    id: 3,
    name: 'Premium',
    price: '$99',
    period: '/month',
    features: [
      'Unlimited chat',
      'Unlimited tool usage',
      '24/7 priority support',
    ],
    buttonText: 'Choose Premium',
    buttonType: 'primary',
  },
  {
    id: 4,
    name: 'Organization',
    price: 'Custom',
    period: '',
    features: [
      'Team collaboration tools',
      'Custom integrations',
      'Dedicated account manager',
      'Advanced security features',
      'Custom training & onboarding',
    ],
    buttonText: 'Contact Sales',
    buttonType: 'primary',
  },
  {
    id: 5,
    name: 'Enterprise',
    price: 'Custom',
    period: '',
    features: [
      'Everything in Organization',
      'On-premise deployment',
      'Custom SLA',
      'White-label options',
      'Dedicated infrastructure',
    ],
    buttonText: 'Contact Sales',
    buttonType: 'primary',
  },
];

